<tt-page>
    <tt-list class="col-xs-12 col-md-4 sp-0" [ttData]="itemsListActivities"></tt-list>
</tt-page>
